import React from "react";
import { Box, Grid, Paper, Stack, Typography } from "convertupleads-theme";
import InhWhiteContainedButtonGroup from "./ContainedWhiteGroup/inhWhiteContainedButtonGroup";
import InWhiteButtonGroupHorzSplit from "./ContainedWhiteGroup/InWhiteButtonGroupHorzSplit";

const WhiteContainedBtnGroup = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          White Themed Contained Button Group
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          White Themed Contained Button Group filled with white background and
          styled with shadow and divider.
        </Typography>
      </Box>
      <Paper
        elevation={0}
        sx={{
          width: "80%",
          alignSelf: "center",
        }}
      >
        <Grid container rowSpacing={2} columnSpacing={2}>
          <Grid item xs={6}>
            <InhWhiteContainedButtonGroup />
          </Grid>
          <Grid item xs={6}>
            <InWhiteButtonGroupHorzSplit />
          </Grid>
        </Grid>
      </Paper>
    </Stack>
  );
};

export default WhiteContainedBtnGroup;
